<script setup lang="ts">
import { computed } from 'vue';
import { format } from 'date-fns';
import Message from '@/stores/communication/Message';

const props = defineProps<{
	message: Message;
	meId: number | undefined;
	showSenderName: boolean;
}>();
const message = props.message;
const meId = props.meId;
const showSenderName = props.showSenderName;

const isMe = computed(() => message.sender?.id === meId);

const bubbleClass = computed(() =>
	isMe.value ? 'bg-blue' : 'bg-grey-lighten-1'
);

const senderName = computed(
	() => message.sender.profile?.first_name || message.sender?.email || 'System'
);

const formattedMessage = computed(() =>
	message.message ? message.message.replace(/\n/g, '<br/>') : ''
);

const timeLabel = computed(() => {
	return message.created_at
		? format(new Date(message.created_at), 'hh:mma')
		: '';
});

const attachmentUrl = computed(() => {
	return message.attachment_path
		? `${import.meta.env.VITE_API_BASE_URL || ''}/storage/${
				message.attachment_path
		  }`
		: '';
});
</script>

<template>
	<div
		:class="[
			'd-flex',
			meId === message.sender?.id ? 'justify-end' : 'justify-start',
		]"
	>
		<v-card :elevation="0" :class="bubbleClass" style="max-width: 70%">
			<v-card-title class="py-2" v-if="!isMe && showSenderName">
				<div>{{ senderName }}</div>
			</v-card-title>

			<v-card-text class="py-2">
				<div v-html="formattedMessage"></div>
				<div v-if="message.attachment_path" class="mt-2">
					<a :href="attachmentUrl" target="_blank">Attachment</a>
				</div>
			</v-card-text>

			<v-card-subtitle class="text-right text-caption pb-2">
				{{ timeLabel }}
			</v-card-subtitle>
		</v-card>
	</div>
</template>
